"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICES_EXPOSED_ON_RPC = exports.services = void 0;
var services;
(function (services) {
    services["assignation"] = "assignation";
    services["authentication"] = "authentication";
    services["authorization"] = "authorization";
    services["blacklistedDate"] = "blacklistedDate";
    services["calculator"] = "calculator";
    services["checking"] = "checking";
    services["content"] = "content";
    services["dbPool"] = "dbPool";
    services["discover"] = "discover";
    services["driver"] = "driver";
    services["driversCompany"] = "driversCompany";
    services["email"] = "email";
    services["feedback"] = "feedback";
    services["file"] = "file";
    services["mangopay"] = "mangopay";
    services["mangopayApi"] = "mangopayApi";
    services["maps"] = "maps";
    services["notification"] = "notification";
    services["order"] = "order";
    services["orderManagement"] = "orderManagement";
    services["orderChangeLog"] = "orderChangeLog";
    services["payment"] = "payment";
    services["alipayPayment"] = "alipayPayment";
    services["payout"] = "payout";
    services["pdf"] = "pdf";
    services["referral"] = "referral";
    services["reservation"] = "reservation";
    services["search"] = "search";
    services["slack"] = "slack";
    services["travelAgent"] = "travelAgent";
    services["typeorm"] = "typeorm";
    services["user"] = "user";
    services["userRoles"] = "userRoles";
    services["vehicle"] = "vehicle";
    services["export"] = "export";
    services["s3Files"] = "s3Files";
    services["s3ReportsFiles"] = "s3ReportsFiles";
    services["s3ContentFiles"] = "s3ContentFiles";
    services["s3Settlements"] = "s3Settlements";
    services["invoice"] = "invoice";
    services["currency"] = "currency";
    services["billingInformation"] = "billingInformation";
    services["mangopayReport"] = "mangopayReport";
    services["mangopayReportDownload"] = "mangopayReportDownload";
    services["reservationPayment"] = "reservationPayment";
    services["validation"] = "validation";
    services["sitemap"] = "sitemap";
    services["reporting"] = "reporting";
    services["hyperwallet"] = "hyperwallet";
    services["hyperwalletApi"] = "hyperwalletApi";
    services["checkoutApi"] = "checkoutApi";
    services["checkout"] = "checkout";
    services["stripeApi"] = "stripeApi";
    services["stripe"] = "stripe";
    services["cooperationAgreementDynamicForm"] = "cooperationAgreementDynamicForm";
    services["unavailability"] = "unavailability";
    services["routeDuplication"] = "routeDuplication";
    services["redirectionLinkGenerator"] = "redirectionLinkGenerator";
    services["hostAgency"] = "hostAgency";
    services["route"] = "route";
    services["routeGeneration"] = "routeGeneration";
    services["hostAgencyChangeLog"] = "hostAgencyChangeLog";
    services["travelAgentChangeLog"] = "travelAgentChangeLog";
    services["apiPartnerChangeLog"] = "apiPartnerChangeLog";
    services["document"] = "document";
})(services || (exports.services = services = {}));
// Services currently exposed on RPC (management frontend)
// As services are migrated to tRPC, remove them from this list
exports.SERVICES_EXPOSED_ON_RPC = [
    services.assignation,
    services.authentication, // Migrated to tRPC - 2025-11-05 - BROUGHT BACK because of external users. DON'T REMOVE THIS SERVICE
    services.billingInformation,
    services.blacklistedDate,
    services.checkout,
    services.content,
    // services.cooperationAgreementDynamicForm, // Migrated to tRPC - 2025-12-04
    services.currency,
    services.document,
    services.driver,
    // services.driversCompany, // Migrated to tRPC - 2025-11-11
    services.email,
    services.export,
    services.feedback,
    services.hostAgency,
    services.hyperwallet,
    // services.invoice, // Migrated to tRPC - 2025-12-03
    services.mangopay,
    services.maps,
    services.notification,
    services.order,
    services.orderChangeLog,
    services.orderManagement,
    services.payment,
    services.payout,
    services.referral,
    // services.route, // Migrated to tRPC - 2025-11-05
    services.routeDuplication,
    services.search,
    services.stripe,
    // services.user, // Migrated to tRPC - 2025-12-23 (integration tests migrated 2025-12-26)
    // services.unavailability, // Migrated to tRPC - 2025-12-10
    services.travelAgent,
    services.vehicle,
    // ------ services used only in testing and not in management
    services.calculator, // used in integration-tests
    services.checking,
];
//# sourceMappingURL=services.enum.js.map